// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7642) return "static/chunks/94a7ad86-b7ab0ab0682c5e3a.js";
	if (chunkId === 3540) return "static/chunks/3540-16b7eabccf5f4423.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2825":"29d08900","8688":"3e93f04a"}[chunkId] || chunkId) + "." + {"853":"c2130e288dd5e688","2825":"f7acae188c97f7a4","2854":"a49525728d9df625","5721":"cbb8a84e98ad7a1a","7945":"7b508fc6d21f3e72","8688":"e7c5c2e62d536977"}[chunkId] + ".js";
};